import { slideUp, slideDown } from '../util/slide.js';

export default class DS {
  constructor() {
    this.init();
  }

  init() {
    /* eslint-disable no-console */
    // console.log('Disability services');
    /* eslint-enable no-console */
    // Module Faq
    const moduleFaq = Array.from(document.querySelectorAll("[data-module='faqs']"));
    moduleFaq.forEach(module => {
      new Faq(module);
    });
  }
}


class Faq {
  constructor(element) {
    this.el = element;
    this.faqsTriggers = Array.from(this.el.querySelectorAll('button'));
    this.faqsTargets = Array.from(this.el.querySelectorAll('section'));
    if (!this.faqsTriggers || !this.faqsTargets) {
      return;
    }
    this.init();
  }

  init() {
    this.faqsTargets.forEach((faq) => {
      const triggers = this.faqsTriggers.filter(trigger => trigger.getAttribute('aria-controls') === faq.id);
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.toggle(faq, trigger, this);
        });
      });
    });
  }

  toggle(faq, trigger) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true' || false;
    if (isExpanded) {
      slideUp(faq, 500);
    }
    trigger.setAttribute('aria-expanded', !isExpanded);
    if (!isExpanded) {
      slideDown(faq, 500);
    }
  }

}



// WEBPACK FOOTER //
// ./scripts/components/disability-services.js